import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ShopProvider } from '@/providers/ShopProvider';
import { CartProvider } from '@/providers/CartProvider';
import { QueueContextProvider } from '@/providers/QueueContext';
import { LanguageProvider } from '@/providers/LanguageProvider';
import { HeartbeatProvider } from '@/providers/HeartbeatProvider';

export const Route = createFileRoute('/$slug/_layout')({
  component: ShopLayout,
});

function ShopLayout() {
  const { slug } = Route.useParams();
  
  return (
    <ShopProvider shopSlug={slug} baseUrl={import.meta.env.VITE_API_URL} isStandalone={true} usePageBackground={true}>
      <LanguageProvider shopSlug={slug}>
        <HeartbeatProvider>
          <QueueContextProvider isQueueActive={false}>
            <CartProvider>
              <Outlet />
            </CartProvider>
          </QueueContextProvider>
        </HeartbeatProvider>
      </LanguageProvider>
    </ShopProvider>
  );
} 
